<template>
	<div class="personnelManage-body">
        <div class="fx-header">
			<p>支付设置</p>
		</div>
		<Search @getTableData="getTableDataHandle" @getParamsData="getParamsData"></Search>
        <div class="table-box">
            <el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				border>
				<!-- <el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column> -->
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="name"
					label="店铺名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="code"
					label="店铺编号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="paynames"
					label="支付方式"
					align="center"
					min-width="180">
					<!-- <template slot-scope="scope">
						<span v-if='scope.row.paymode === 0'>不限</span>
						<span v-if='scope.row.paychannel === 1'>微信支付</span>
						<span v-if='scope.row.paychannel === 2'>招行支付</span>
						<span v-if='scope.row.paychannel === 3'>民生银行</span>
					</template> -->
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button v-if="AuthorityList['04_0001_0001_00'] || AuthorityList['04_0001_0002_00'] " @click="showClick(scope.row)" type='text' size="mini">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
        </div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20,40, 60, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
	</div>
</template>
<script>
import Search from '@/components/payCenter/Search.vue'
export default {
	name: 'personnelManage',
	components: {
		Search
	},
	data () {
		return {
			AuthorityList: {
				'04_0001_0001_00': false,
				'04_0001_0002_00': false

			},
			payMode: -1,
			content: '',
			code: '',
			tableData: [{ id: 1 }],
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			}
		}
	},
	created () {
		this.tableReload()
		this.getAuthority('04_0001_0000_00')
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getTableDataHandle (data) {
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			// console.log(data)
			this.page.number = data.page
			this.page.size = data.size
			this.content = data.content
			this.code = data.code
			this.payMode = data.payMode
		},
		showClick (data) {
			let a = JSON.stringify(data)
			this.$router.push({ path: 'payCenterEdit', query: { editData: a } })
		},
		tableReload () {
			let params = {
				content: this.content,
				code: this.code,
				paychannel: this.payMode,
				page: this.page.number,
				size: this.page.size
			}
			// if (this.payMode !== 9) {
			// 	params.payMode = this.payMode
			// }
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/payCenter/list`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.recordList.forEach(item => {
						let arr = []
						let way = ['微信支付', '招行支付', '民生银行']
						if (item.paychannel !== 0) {
							arr.push(way[item.paychannel - 1])
						}
						if (item.tenpay === 1) {
							arr.push('微企付')
						}
						item.payMethod = arr.join(',')
					})
					this.tableData = res.data.recordList
					this.total = res.data.recordCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.personnelManage-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    .table-box{
        padding-bottom :10px;
        height :calc(100% - 200px)
    }
    padding-bottom :50px;
    .btn-box{
        width :90%;
        padding :15px;
        text-align :left
    }
}

</style>
<style lang="stylus">
.personnelManage-body {
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
